import {useAppSelector} from "../../../redux/hooks";
import {
  getFullLibrarySongCardResults as getMySongsLibraryFullLibrarySongCardResults,
  getFullLibraryFilteredTotal as getMySongsLibraryFullLibraryFilteredTotal,
  IMySongsLibraryFullLibrarySongCardResult,
} from "../../../pages/songs-router/modules/my-songs-library-store/mySongsLibrary.selector";
import {mySongsLibraryStore} from "../../../pages/songs-router/modules/my-songs-library-store/mySongsLibrary.store";

export interface ISongsResultsBrowseLogic {
  totalSongs: number;
  totalFilteredSongs: number;
  filteredSongs: IMySongsLibraryFullLibrarySongCardResult[];
}

export const useSongsResultsBrowseLogic = (): ISongsResultsBrowseLogic => {
  const totalSongs = useAppSelector(mySongsLibraryStore.getFullLibrary).length;
  const totalFilteredSongs = useAppSelector(getMySongsLibraryFullLibraryFilteredTotal);
  const filteredSongs = useAppSelector(getMySongsLibraryFullLibrarySongCardResults);
  return {
    totalSongs,
    totalFilteredSongs,
    filteredSongs,
  };
}
